import { BrandLogo, type BrandName } from "@/components/icons/brand-logo";
import type { Skill } from "./types";

// Curated capability matrix for the "How I Work" section.
// Sourced from BRAND_REGISTRY (single source of truth) — adding a
// new integration here only requires picking an existing brand key.
const make = (brand: BrandName, name: string): Skill => ({
  icon: <BrandLogo name={brand} className="w-6 h-6" />,
  name,
});

export const skillRows: Skill[][] = [
  // Row 1 — Social, communication & CRM
  [
    make("facebook", "Facebook"),
    make("instagram", "Instagram"),
    make("whatsapp", "WhatsApp"),
    make("linkedin", "LinkedIn"),
    make("tiktok", "TikTok"),
    make("youtube", "YouTube"),
    make("twitter", "Twitter/X"),
    make("slack", "Slack"),
    make("zoom", "Zoom"),
    make("teams", "Teams"),
    make("discord", "Discord"),
    make("twilio", "Twilio"),
    make("googlemeet", "Google Meet"),
    make("salesforce", "Salesforce"),
    make("hubspot", "HubSpot"),
  ],
  // Row 2 — Finance, e-commerce & support
  [
    make("stripe", "Stripe"),
    make("quickbooks", "QuickBooks"),
    make("xero", "Xero"),
    make("paypal", "PayPal"),
    make("square", "Square"),
    make("shopify", "Shopify"),
    make("woocommerce", "WooCommerce"),
    make("amazon", "Amazon"),
    make("etsy", "Etsy"),
    make("zendesk", "Zendesk"),
    make("intercom", "Intercom"),
    make("freshdesk", "Freshdesk"),
    make("pipedrive", "Pipedrive"),
  ],
  // Row 3 — Productivity, marketing & tools
  [
    make("notion", "Notion"),
    make("airtable", "Airtable"),
    make("asana", "Asana"),
    make("trello", "Trello"),
    make("monday", "Monday.com"),
    make("jira", "Jira"),
    make("gmail", "Gmail"),
    make("outlook", "Outlook"),
    make("mailchimp", "Mailchimp"),
    make("autosend", "ActiveCampaign"),
    make("googleanalytics", "Analytics"),
    make("googledrive", "Drive"),
    make("googlesheets", "Sheets"),
    make("calendly", "Calendly"),
    make("typeform", "Typeform"),
    make("dropbox", "Dropbox"),
  ],
];
